import LandingPageLayout from "@/layouts/landing-page-layout";
import RootLayout from "@/layouts/root-layout";
import VouchGuard from "@/layouts/vouch-guard";
import {
  ContactUs,
  Home,
  InitiateVouch,
  NotFound,
  PrivacyPolicy,
  QualifyForVouch,
  TermsAndConditions,
  Unsubscribe,
  VouchAboutYou,
  VouchComplete,
  Vouching,
  VouchingVerify,
} from "@/pages";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Route, Routes } from "react-router";

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route element={<RootLayout />}>
          <Route element={<LandingPageLayout />}>
            <Route path="/" element={<Home />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/contact-us" element={<ContactUs />} />
            {/* Remove this after launch, this is just for /waitlist?ref={source} */}
            <Route path="/waitlist" element={<Home />} />
          </Route>
          <Route path="/vouch/:vouchId" element={<VouchGuard />}>
            <Route index element={<Vouching />} />
            <Route path="qualify" element={<QualifyForVouch />} />
            <Route path="respond" element={<InitiateVouch />} />
            <Route path="about-you" element={<VouchAboutYou />} />
            <Route path="verify" element={<VouchingVerify />} />
          </Route>
          <Route path="/vouch/:vouchId/complete" element={<VouchComplete />} />
          <Route path="/unsubscribe/:token" element={<Unsubscribe />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </QueryClientProvider>
  );
}
